import { Component} from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'convfact-helptabs',
    templateUrl: './help-tabs.component.html',
    styleUrls: ['./help-tabs.component.scss'],
    standalone: false
})
export class HelpTabsComponent {
  routes: object[];

  constructor(private router: Router) {
    this.routes = [
      { label: 'Cuentas Ingresos', link: '/help/entrance' , enable: true},
      { label: 'Cuentas Gastos', link: '/help/expense' , enable: true},
      { label: 'Cuentas de Bancos', link: '/help/bankaccount' , enable: true},
    ];
  }
}
